<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" class="py-0">
        <template>
          <v-row>
            <v-col>
              <div class="scroll-wrapper">
                <template v-if="items.length">
                  <v-virtual-scroll
                    :items="items"
                    :item-height="listItemHeight"
                    :height="virtualScrollHeight"
                    class="scroll-list"
                    ref="listContainer"
                  >
                    <template v-slot:default="{ item }">
                      <v-list-item
                        :key="item.id"
                        class="list-item"
                        @click="() => {}"
                      >
                        <v-list-item-content class="item-content">
                          <div class="content-wrapper">
                            <slot name="listItem" v-bind:item="item"></slot>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-virtual-scroll>
                  <ui-button
                    :disabled="!selected"
                    color="primary"
                    class="my-2 mx-2"
                    @click="$emit('delete')"
                  >
                    {{ $t("message.common.deleteSelected") }}
                  </ui-button>
                </template>
                <no-data
                  v-if="!items.length && !loading"
                  :description="$t('message.common.noDataDescription')"
                ></no-data>
                <SectionLoader :status="loading" :opacity="0.75" />
              </div>
            </v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import NoData from "@/components/ui/NoData.vue";
import SectionLoader from "@/components/Loader/SectionLoader.vue";
export default {
  name: "BaseLimitManagement",
  components: { NoData, SectionLoader },
  props: {
    items: {
      type: Array,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listItemHeight: 66,
      selectedItem: {}
    };
  },
  computed: {
    virtualScrollHeight() {
      return this.items.length < 5
        ? this.listItemHeight * (this.items.length + 1)
        : this.listItemHeight * 5;
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.scroll-wrapper {
  min-height: 200px;
}

.scroll-list {
  border-radius: 4px;
  margin-bottom: $spacing * 3;
  border: 1px solid $gray-lighter;
}

.list-item {
  &:nth-child(odd):not(.active) {
    background-color: #fcfcfc;
  }
}

.item-content {
  width: 100%;
  padding: 0 $spacing !important;
}

.content-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}
</style>
